import React from "react";

export default function PrivacyPolicy() {
  return (
    <>
      {/* Inline styles for Privacy Policy page */}
      <style>{`
        body {
          background-image: url('/F.jpg');
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          font-family: 'Poppins', sans-serif;
          margin: 0;
        }

        .terms-main-container {
          margin: 2rem auto;
          padding: 2rem;
          max-width: 800px;
          background-color: rgba(255, 255, 255, 0.164);
          box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.363);
          backdrop-filter: blur(30px);
          border: 2px solid rgba(255, 255, 255, 0.24);
          border-radius: 20px;
        }
        .terms-header {
          text-align: center;
          margin-bottom: 1rem;
        }
        .terms-header img {
          display: block;
          margin: 0 auto 1rem;
          width: 100px;
        }
        .terms-header h1 {
          font-size: 2rem;
          color: rgb(15, 133, 202);
          margin-bottom: 0.5rem;
        }
        .terms-header hr {
          border: none;
          border-top: 2px solid rgba(15, 133, 202, 0.5);
          margin: 0 auto;
          width: 50%;
        }
        .first-block {
          margin-top: 2rem;
        }
        .terms-title {
          font-size: 1.5rem;
          color: rgb(15, 133, 202);
          margin-bottom: 0.5rem;
        }
        .terms-info {
          color: white;
          font-size: 1rem;
          line-height: 1.5;
          margin-bottom: 1rem;
        }
        .term-list {
          margin-left: 1.5rem;
          color: white;
          font-size: 0.9rem;
          list-style: disc;
        }
        .ending-terms {
          color: rgb(216, 225, 255);
          text-align: center;
          margin-top: 2rem;
          font-style: italic;
        }
      `}</style>

      <div className="terms-main-container">
        {/* Company Logo */}
        <img src="/wayuvega.png" alt="Wayuvega Logo" />

        <section className="terms-header">
          <h1>Privacy Policy</h1>
          <hr />
        </section>

        <div className="terms-body">
          <div className="first-block">
            <p className="terms-title">Introduction</p>
            <p className="terms-info">
              wayuvega ("we," "our," or "us") values your privacy. This Privacy Policy outlines how we collect, use, disclose, and safeguard your information when you use our services. By accessing our services, you agree to this Privacy Policy.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">Information We Collect</p>
            <p className="terms-info">
              We may collect the following types of information:
            </p>
            <ul className="term-list">
              <li>Personal Information: Name, email address, phone number, and other contact details.</li>
              <li>Transaction Information: Details about services availed and payments made.</li>
              <li>Technical Information: IP address, browser type, and device information.</li>
            </ul>
          </div>

          <div className="first-block">
            <p className="terms-title">How We Use Your Information</p>
            <p className="terms-info">
              We use your information to:
            </p>
            <ul className="term-list">
              <li>Provide and manage our services.</li>
              <li>Communicate with you about updates, offers, and support.</li>
              <li>Enhance our services and user experience.</li>
            </ul>
          </div>

          <div className="first-block">
            <p className="terms-title">Information Sharing and Disclosure</p>
            <p className="terms-info">
              We do not sell your personal information. However, we may share your information with:
            </p>
            <ul className="term-list">
              <li>Service providers who assist us in delivering our services.</li>
              <li>Law enforcement or regulatory authorities, if required by law.</li>
              <li>Third parties in connection with business transfers, such as mergers or acquisitions.</li>
            </ul>
          </div>

          <div className="first-block">
            <p className="terms-title">Data Security</p>
            <p className="terms-info">
              We implement appropriate technical and organizational measures to protect your information from unauthorized access, disclosure, or loss.
            </p>
          </div>

          <div className="first-block">
            <p className="terms-title">Your Rights</p>
            <p className="terms-info">
              You have the right to:
            </p>
            <ul className="term-list">
              <li>Access and review your personal information.</li>
              <li>Request correction or deletion of your personal information.</li>
              <li>Opt-out of marketing communications.</li>
            </ul>
          </div>

          <div className="first-block">
            <p className="terms-title">Changes to this Privacy Policy</p>
            <p className="terms-info">
              We may update this Privacy Policy from time to time. Any changes will be communicated via our website or other official channels.
            </p>
          </div>

          <p className="ending-terms">
            Thank you for choosing wayuvega! We look forward to serving you.
          </p>
        </div>
      </div>
    </>
  );
}
